import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import { ToastContainer } from 'react-toastify';
import { getCookie } from '@utils/cookie';

import GlobalStyles from '@styles/GlobalStyles';
import theme from '@styles/theme';
import { userVar, didInfoVar } from './store';

import Router from './Router';
function App() {
    const { pathname } = useLocation();
    const isLoggedIn = getCookie('HMT') ?? false;

    useEffect(() => {
        if (isLoggedIn) {
            userVar({ version: 1, agreement: false, advertiser: true });
            didInfoVar({
                version: 1,
                type: 1, // 1.0 일 경우, 1: 종합형, 2: 공지형, 3: 이미지형, 4: 기기구입형
                didTextMsg: true, // 하단 자막 사용 여부
                usePatientChart: true, // 차트 사용 여부
                useCallingPati: false, // 환자 호출 사용 여부
                notationMethod: 1, // 1: 진료실명, 2: 의사명
                didBgColor: '#ededed', // DID 배경 색상
                didPointColor: '#ff5700', // 환자 강조 색상
                useWeatherAni: false // 날씨 애니메이션 사용 여부
            });
        }
    }, [isLoggedIn]);

    useEffect(() => {
        document.oncontextmenu = () => {
            return false;
        };
        window.scrollTo(0, 0);
    }, [pathname]);

    return (
        <ThemeProvider theme={theme}>
            <ToastContainer autoClose={2000} />
            <GlobalStyles />
            <Router isLoggedIn={isLoggedIn} />
        </ThemeProvider>
    );
}

export default App;
